import { render, staticRenderFns } from "./SdsIndexErrorPage.vue?vue&type=template&id=76ef9cfe"
import script from "./SdsIndexErrorPage.vue?vue&type=script&lang=ts"
export * from "./SdsIndexErrorPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports